export default {
  "content": "<g clip-path=\"url(#clip0_83_81975)\" fill=\"#3F4450\"><path d=\"M20.579 24.464a13.978 13.978 0 01-9.177-15.037c.18-1.227.525-2.424 1.028-3.558a.94.94 0 00-1.054-1.284A13.888 13.888 0 00.146 16.022a13.97 13.97 0 0024.756 10.709.938.938 0 00-.658-1.522 14.075 14.075 0 01-3.665-.745zM25.608.349l2.044 5.232 4.113 3.143a.528.528 0 010 .827l-4.113 3.144-2.044 5.232a.53.53 0 01-.997 0l-2.044-5.232-4.113-3.144a.528.528 0 010-.827l4.113-3.143L24.61.349a.53.53 0 01.997 0z\"/></g><defs><clipPath id=\"clip0_83_81975\"><path fill=\"#fff\" d=\"M0 0h32v32H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};